var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReverseGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 792.358 8",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".topbar-cls-2{fill:url(#linear-gradient2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 102.487,
    y1: 682.662,
    x2: 107.066,
    y2: -63.658,
    gradientTransform: "translate(710.224 -101.177) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#98c3ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#75af8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#51a790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#259d93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#0a9794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#009595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#00788a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#1a516c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#263f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#2d405e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#3f425c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#5d4558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#884953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#bb4e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e47864"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "topbar-cls-2",
    width: 792.358,
    height: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseGradient);
export default __webpack_public_path__ + "static/media/reverseGradient.e64ab81097aa54a5c5845f2d33c81cfe.svg";
export { ForwardRef as ReactComponent };